module.exports = __webpack_public_path__ + "static/media/my_cha.0b5dd4ec.svg";